import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import Loader from "../../components/Loader";
import { CustomButton } from "../../components/CustomButton";
import { AddCustomer } from "../../components/Forms/AddCustomer";
import { Column } from "primereact/column";
import { ReactComponent as Edit } from "../../svg/edit.svg";
import { ReactComponent as Delete } from "../../svg/delete.svg";
import { ReactComponent as Subs } from "../../svg/subs.svg";
import { ReactComponent as CustomerIcon } from "../../svg/addcustomer.svg";
import { useDispatch, useSelector } from "react-redux";
import { DeleteAlert } from "../../components/Alert/DeleteAlert";
import CustomPaginator from "../../components/CustomPaginator";
import CreateGroup from "../../components/CreateGroup";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

import { useDebounce } from "primereact/hooks";

import {
  changeMode,
  resetMode,
  changePage,
  resetSelectedCustomer,
  changeSelectedCustomer,
  getCustomers,
  setCform,
  changelimit,
} from "../../reducers/customerSlice";

const CustomerList = () => {
  const [displayBasic, setDisplayBasic] = useState(false);
  const [displayAlertDelete, setDisplayAlertDelete] = useState(false);
  const [searchText, debouncedValue, setSearchText] = useDebounce("", 1000);

  const toast = useRef(null);
  const dispatch = useDispatch();
  const {
    customerData,
    page,
    limit,
    loading,
    totalCustomerCount,
    refresher,
    // showCustomersType,
  } = useSelector((state) => state.customer);

  const modalLoad = () => {
    return <Loader visible={loading} />;
  };

  // const onAddNewClick = () => {
  //   dispatch(setCform("company"));
  //   setDisplayBasic((prev) => !prev);
  // };

  const onHide = () => {
    setDisplayBasic(false);
    dispatch(resetSelectedCustomer());
    dispatch(resetMode());
  };

  const handleEdit = (customer, form) => {
    //dont touch the sequence hazardous
    dispatch(changeMode("update"));
    if (form === "subscription" && customer.name === null) {
      dispatch(changeMode(""));
    }
    dispatch(setCform(form));
    dispatch(changeSelectedCustomer(customer));
    setDisplayBasic(true);
  };

  const handleDelete = (customer) => {
    setDisplayAlertDelete(true);
    dispatch(changeSelectedCustomer(customer));
  };

  const deleteModule = () => {
    return (
      <DeleteAlert
        item="customer"
        displayAlertDelete={displayAlertDelete}
        setDisplayAlertDelete={setDisplayAlertDelete}
        toast={toast}
      />
    );
  };

  const addCustomerModal = () => {
    return (
      <AddCustomer onHide={onHide} displayBasic={displayBasic} toast={toast} />
    );
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex">
        <CustomButton
          varient="icon-button"
          onClick={() => handleEdit(rowData, "company")}
          icon={<Edit />}
        />
        <CustomButton
          varient="icon-button"
          onClick={() => handleDelete(rowData)}
          icon={<Delete />}
        />
      </div>
    );
  };

  const conversation = (rowData) => {
    return (
      <div>
        {rowData.usedConversation | 0}/{rowData.totalConversation | 0}
      </div>
    );
  };

  const renderHeader1 = () => {
    return (
      <div className="lg:flex justify-content-end  lg:mb-0 sm:mb-0">
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="text"
            value={searchText}
            placeholder="Search by name"
            onChange={(e) => setSearchText(e.target.value)}
          />
        </span>
      </div>
    );
  };
  const header1 = renderHeader1();
  //search end---------------------

  useEffect(() => {
    dispatch(getCustomers({ page, limit, searchText }))
      .unwrap()
      .catch(() => {
        //show toast from here
      });
  }, [refresher, page, debouncedValue, limit]);

  // const usercol = (rowData) => {
  //   return (
  //     <div className="flex">
  //       <CustomButton
  //         varient="icon-button"
  //         onClick={() => handleEdit(rowData, "user")}
  //         icon={<CustomerIcon />}
  //       />
  //     </div>
  //   );
  // };

  // const subscol = (rowData) => {
  //   return (
  //     <div className="flex">
  //       <CustomButton
  //         varient="icon-button"
  //         onClick={() => handleEdit(rowData, "subscription")}
  //         icon={<Subs />}
  //       />
  //     </div>
  //   );
  // };
  return (
    <div className="w-11 m-auto">
      <Toast ref={toast} />
      {displayBasic ? addCustomerModal() : <></>}
      {loading ? modalLoad() : <></>}
      {deleteModule()}
      {/* <div className={`flex justify-content-end align-items-center gap-2`}>
        <div className="hidden md:block lg:block xl:block">
          <CustomButton
            varient="filled"
            label={"Add New Customer"}
            icon={"pi pi-plus"}
            onClick={onAddNewClick}
          />
        </div>
      </div> */}
      <div className="mt-3">
        <div>
          <DataTable
            value={customerData}
            dataKey="companyId"
            responsiveLayout="scroll"
            resizableColumns
            columnResizeMode="expand"
            className="skalebot-table"
            globalFilterFields={["name"]}
            header={header1}
          >
            <Column field="companyId" header="Customer Id" />
            <Column header="Customer Name" field="companyName" />
            <Column header="Phone No" field="phone" />
            <Column
              field="email"
              header="Email"
              bodyStyle={{ textTransform: "lowercase" }}
            />
            <Column header="Version" field="name" />
            <Column header="Campaign" field="campaignsCount" />
            <Column header="Orders" field="ordersCount" />
            <Column header="Enquiries" field="enquiriesCount" />
            <Column header="Customers" field="customerCount" />
            <Column header="Conversation" body={conversation} />
            {/* <Column header="Users" body={usercol} />
              <Column header="Subscription" body={subscol} /> */}
            <Column
              body={actionBodyTemplate}
              header="Action"
              bodyStyle={{ width: "100px" }}
            ></Column>
          </DataTable>
          <div className="flex justify-content-end">
            <CustomPaginator
              page={page}
              limit={limit}
              changelimit={changelimit}
              totalRecords={totalCustomerCount || 0}
              changePage={changePage}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerList;
